<div style="height: 100%; display: flex; justify-content: center; align-items: center;">
    <account-status-chart [showTitle]="false" style="height: 100%; flex-grow: 1; width: 100%;" [startDate]="null" [endDate]="null"></account-status-chart>
    <div style="height: 100%; display: block; margin: 15px;">
        <div class="panel panel-info" style="height:100%; width: 100%">
            <div class="panel-heading" style="display: flex;">
                <h4>
                    <span>Chart Settings</span>
                </h4>
            </div>
            <div class="panel-body" style="display: flex; align-items: center; justify-content: space-around;">
                <div style="display: flex;">
                    <div>
                        Chart Type:
                    </div>
                    <div class="pull-right">
                        <div class="dropdown">
                            <a href="" class="dropdown-toggle" data-toggle="dropdown">
                                <span>TODO: Add chart option here</span>
                                <b class="caret"></b>
                            </a>
                            <ul class="dropdown-menu">
                                <li *ngFor="let chartType of chartTypes">
                                    <a (click)="changeChartType(chartType)">{{ chartType }}</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
